import { render, staticRenderFns } from "./RewardPeerToPeer.vue?vue&type=template&id=523f67b4&"
import script from "./RewardPeerToPeer.vue?vue&type=script&lang=js&"
export * from "./RewardPeerToPeer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports